import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import Ads from '../Ads/Ads'
import Foot2 from '../Foot2/Foot2'
import NewsDivs from '../NewsDivs/NewsDivs'
import TopBar from '../TopBar/TopBar'
import Spinner from '../Spinner/Spinner';
import "./topicsnews.css"

function TopicsNews() {

  const { id } = useParams()

  const [section, setSection] = useState(false);

  const [page, setPage]  = useState()

   const [loading, setLoading] = useState(true)

  console.log(!section)

 
  
  const getSectionnews = async () => {

    setLoading(true)
    const response = await fetch(`https://nairalandclone.herokuapp.com/newsapi/${id}`);
    const datum = await response.json()
    console.log(id)
    setSection(datum)
    setLoading(false)
   }

  useEffect(() => {
    getSectionnews()
  },[])


  return (
    <>
      <TopBar />
      <div className='topicsnews'>
        <div className="head">{ id.replace(",","") } - Nairaland</div>
        <div className="breadcrumbs"> <Link to="/">Nairaland Forum &nbsp;</Link> / <Link to="/">&nbsp; {id}</Link></div>
        <div className="adrate"></div>
        <Ads />
         <div className="pages">     <div> (1) </div>&nbsp; <di> (2) </di> &nbsp; <div> (3) </div>&nbsp; <div> (4) </div>&nbsp; <div> (5) </div> &nbsp;<div> (6) </div>&nbsp; <div> (7) </div>&nbsp; <div> (8) </div>&nbsp; <div> (9) </div> &nbsp;<div> (10) </div>&nbsp; <div>(Create New Topic)</div>
        </div>
        <div className="topmost"><h4>Topics: </h4>&nbsp;<h4><Link to=""> Post</Link> / &nbsp;</h4><h4><Link to=""> Views </Link> /&nbsp; </h4><h4><Link to=""> Updated </Link> /&nbsp; </h4><h4><Link to=""> New</Link></h4></div>
        <div className="news">
            {loading ? <div className="spinn"><Spinner /></div> : 
            section.map((sec) => { 
              return (<a href={sec.url} target= "_blank" rel='noreferrer' id={sec} className="newss">  <NewsDivs title={sec.title} author={sec.author} time={sec.publishedAt} /></a>)
            })
        }
        
        </div>
         <div className="pages">
       <div> (1) </div>&nbsp; <di> (2) </di> &nbsp; <div> (3) </div>&nbsp; <div> (4) </div>&nbsp; <div> (5) </div> &nbsp;<div> (6) </div>&nbsp; <div> (7) </div>&nbsp; <div> (8) </div>&nbsp; <div> (9) </div> &nbsp;<div> (10) </div>&nbsp; <div>(Create New Topic)</div>
      </div>
        <Ads />
        <div className="go">(Go Up)</div>
        <div className="online">6 guest(s)</div>
      </div>
      <Foot2 />
    </>
  )
}

export default TopicsNews